import './ThinkingScreen.scss';

export default function ThinkingScreen() {
  return <div className="thinking-screen">Moxi is thinking...</div>;
}
